import { NgModule } from '@angular/core';
import { AnnualPipe } from './annual.pipe';

@NgModule({
  declarations: [AnnualPipe],
  exports: [AnnualPipe],
})
export class AnnualModule {}
